import React, { Component } from "react";
import { Container, Row, Col, Card, CardHeader, CardBody } from "shards-react";
import { getTeacherDetails, deleteUser } from "../services/api";
import { Store } from "../flux";
import PageTitle from "../components/common/PageTitle";
import DarkTable from "./DarkTable";
import EditUser from "./EditUser";
import AddUser from "./AddUser";
import Load from "../Load";

class ManageTeachers extends Component {
  tableData = [];
  constructor(props) {
    super(props);
    this.state = {
      user: Store.getCurrentUser(),
      selectedUser: null,
      loading: true,
      add: false,
      edit: false,
      heads: [],
      rows: [],
      originalCopy: []
    };

    this.manageClick = this.manageClick.bind(this);
    this.goBack = this.goBack.bind(this);
    this.addTeacher = this.addTeacher.bind(this);
  }
  componentDidMount() {
    getTeacherDetails(this.state.user.Institution, this.state.user)
      .then(data => {
        let copy = [];
        data.forEach(x => {
          var element = { id: "", FirstName: "", LastName: "", Email: "" };
          element.id = x.id;
          element.FirstName = x.FirstName;
          element.LastName = x.LastName;
          element.Email = x.Email;
          copy.push(element);
        });

        this.setState({
          ...this.state,
          heads: Object.keys(copy[0]),
          rows: copy,
          loading: false,
          originalCopy: data
        });
      })
      .catch(err => {this.setState({...this.state,loading: false})});
  }
  addTeacher() {
    this.setState({ ...this.state, add: true });
  }
  goBack() {
    this.setState({...this.state,loading:true});
    getTeacherDetails(this.state.user.Institution, this.state.user)
      .then(data => {
        let copy = [];

        try {
          data.forEach(x => {
            var element = { id: "", FirstName: "", LastName: "", Email: "" };
            element.id = x.id;
            element.FirstName = x.FirstName;
            element.LastName = x.LastName;
            element.Email = x.Email;
            copy.push(element);
          });

          this.setState({
            ...this.state,
            heads: Object.keys(copy[0]),
            rows: copy,
            originalCopy: data,
            add: false,
            loading:false,
            edit: false
          });
        } catch {
          this.setState({
            ...this.state,
            loading:false,
            selectedUser: null,
            add: false,
            edit: false,
            heads: [],
            rows: [],
            originalCopy: []
          });
        }
      })
      .catch(err => {this.setState({...this.state,loading:false})});
  }
  manageClick(name, id) {
    var result = this.state.originalCopy.filter(obj => {
      return obj.id === id;
    });
    if (name == "Edit") {
      this.setState({ ...this.state, edit: true, selectedUser: result[0] });
    } else {
      deleteUser(id, this.state.user).then(data => {
        this.goBack();
      }).catch(()=>{this.setState({...this.state,loading:false})});
    }
  }
  render() {
    return this.state.loading ? (
      <Container fluid className="main-content-container px-4">
        <Load />
      </Container>
    ) : (this.state.add ? (
      <AddUser
        type={`TEACHER`}
        nav={this.goBack}
        user={this.state.selectedUser}
      ></AddUser>
    ) : this.state.edit ? (
      <EditUser
        type={`Teacher`}
        nav={this.goBack}
        user={this.state.selectedUser}
      ></EditUser>
    ) : (
      <Container fluid className="main-content-container px-4">
        {/* Page Header */}
        <Row noGutters className="page-header py-4">
          <PageTitle
            sm="4"
            title="Manage Teachers"
            subtitle=""
            className="text-sm-left"
          />
        </Row>
        <DarkTable
          add={this.addTeacher}
          manageClick={this.manageClick}
          action={[{ name: "Edit" }, { name: "Delete" }]}
          title={`Students`}
          head={this.state.heads}
          rows={this.state.rows}
        ></DarkTable>
      </Container>
    ));
  }
}

export default ManageTeachers;
